var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H10V20H4V18ZM11.906 11.712C12.936 10.506 14 9.259 14 7C14 3.141 10.859 0 7 0C3.141 0 0 3.141 0 7C0 9.285 1.067 10.528 2.101 11.73C2.459 12.148 2.83 12.581 3.185 13.079C3.329 13.285 3.565 14.075 3.776 15H3V17H11V15H10.226C10.439 14.073 10.676 13.281 10.819 13.075C11.171 12.572 11.545 12.135 11.906 11.712ZM9.182 11.925C8.748 12.542 8.386 14 8.176 15H5.825C5.616 13.998 5.253 12.537 4.814 11.92C4.43876 11.4043 4.03966 10.9065 3.618 10.428C2.644 9.294 2 8.544 2 7C2 4.243 4.243 2 7 2C9.757 2 12 4.243 12 7C12 8.521 11.357 9.274 10.385 10.413C10.012 10.851 9.589 11.346 9.182 11.925Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.e8cc9b49794213ba4a91261229e7ffdb.svg";
export { ForwardRef as ReactComponent };